import Vue from 'vue'
import { mapGetters } from 'vuex'
import { areasMixin } from './areasMixin'

import { zonesNamesRefs } from '../utils/zonesHelpers'

export const officialZonesMixin = {
  mixins: [areasMixin],
  data() {
    return {
      // fromRoute: null,
      // neighborhoodsPath: [],
      // communesPath: [],
      // quadrantsPath: [],
      // stationsPath: [],
      // districtsPath: [],
      // neighborhoodsSelected: [],
      // communesSelected: [],
      // quadrantsSelected: [],
      // stationsSelected: [],
      // districtsSelected: [],
      polygonOptions1: {
        strokeColor: '#9C27B0',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#9C27B0',
        fillOpacity: 0.35,
        zIndex: 1000
      },
      polygonOptions2: {
        strokeColor: '#FFC107',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#FFC107',
        fillOpacity: 0.35,
        zIndex: 500
      },
      polygonOptions3: {
        strokeColor: '#8BC34A',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#8BC34A',
        fillOpacity: 0.35,
        zIndex: 700
      },
      polygonOptions4: {
        strokeColor: '#00BCD4',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#00BCD4',
        fillOpacity: 0.35,
        zIndex: 100
      },
      polygonOptions5: {
        strokeColor: '#673AB7',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#673AB7',
        fillOpacity: 0.35,
        zIndex: 50
      },
      polygonOptions6: {
        strokeColor: '#E53935',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#E53935',
        fillOpacity: 0.35,
        zIndex: 50
      },
      polygonOptions7: {
        strokeColor: '#EF6C00',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#EF6C00',
        fillOpacity: 0.28,
        zIndex: 40
      },
      infoOfficialFenceSelected: {},
      showOfficialFenceName: false
    }
  },
  computed: {
    ...mapGetters([
      'firefightersPath',
      'firefightersSelected',
      'neighborhoodsPath',
      'communesPath',
      'quadrantsPath',
      'stationsPath',
      'districtsPath',
      'neighborhoodsSelected',
      'communesSelected',
      'quadrantsSelected',
      'stationsSelected',
      'districtsSelected',
      'empasPath',
      'empasSelected'
    ]),
    ...mapGetters({
      firefighters: 'filters/getFirefighters',
      neighborhoods: 'filters/getNeighborhoods',
      communes: 'filters/getComunes',
      quadrants: 'filters/getQuadrants',
      stations: 'filters/getStations',
      districts: 'filters/getDistricts'
    }),
    showClearPolygons() {
      let showValue = false
      if (
        this.firefightersSelected.length > 0 ||
        this.neighborhoodsSelected.length > 0 ||
        this.communesPath.length > 0 ||
        this.quadrantsPath.length > 0 ||
        this.stationsPath.length > 0 ||
        this.districtsPath.length > 0 ||
        this.empasPath.length > 0
      ) showValue = true
      return showValue
    }
  },
  methods: {
    // ...mapActions(['saveFromRoute']),
    clearAllPolygons() {
      this.neighborhoodsPath = []
      this.communesPath = []
      this.quadrantsPath = []
      this.stationsPath = []
      this.districtsPath = []
      this.neighborhoodsSelected = []
      this.communesSelected = []
      this.quadrantsSelected = []
      this.stationsSelected = []
      this.districtsSelected = []
    },
    clearZone(from) {
      // console.log('CLEAR ZONE: ', from, this[`${from}Selected`], this[from])
      this[`${from}Selected`] = []
      this[`${from}Path`] = []
    },
    displayZone(from) {
      // console.log('DISPLAY ZONE: ', from, this[`${from}Selected`], this[from])
      if (this[`${from}Selected`] !== undefined || this[`${from}Selected`] !== null) {
        this[`${from}Path`] = []

        this[`${from}Selected`].forEach(element => {
          if (element === 'San Cristóbal' || element === 'SUB San Cristóbal' || element === 'San Javier' || element === 'EST San Javier') {
            // console.log('SPECIAL!!!')
            let zoneAlt1 = []
            let zoneAlt2 = []
            if (element === 'EST San Javier') {
              zoneAlt1 = this[from].filter(item => item.name === 'EST San Javier A')
              zoneAlt2 = this[from].filter(item => item.name === 'EST San Javier B')
            } else if (element === 'SUB San Cristóbal') {
              zoneAlt1 = this[from].filter(item => item.name === 'SUB Corregimiento de San Cristóbal A')
              zoneAlt2 = this[from].filter(item => item.name === 'SUB Corregimiento de San Cristóbal B')
            } else if (element === 'San Javier') {
              zoneAlt1 = this[from].filter(item => item.name === 'San Javier A')
              zoneAlt2 = this[from].filter(item => item.name === 'San Javier B')
            } else {
              zoneAlt1 = this[from].filter(item => item.name === 'San Cristóbal A')
              zoneAlt2 = this[from].filter(item => item.name === 'San Cristóbal B')
            }

            if (zoneAlt1.length > 0) {
              this[`${from}Path`].push(window.google.maps.geometry.encoding.decodePath(zoneAlt1[0].geostring))
            }
            if (zoneAlt2.length > 0) {
              this[`${from}Path`].push(window.google.maps.geometry.encoding.decodePath(zoneAlt2[0].geostring))
            }
          } else {
            const zone = this[from].filter(item => item.name === element)
            // console.log('ZONE: ', zone, this[`${from}Path`])
            // console.log('GEOSTRING: ', zone[0].geostring)
            if (zone.length > 0) {
              this[`${from}Path`].push(window.google.maps.geometry.encoding.decodePath(zone[0].geostring))
              // console.log('PATH: ', this[`${from}Path`])
            }
          }
        })
      } else {
        this[`${from}Selected`] = []
        this[`${from}Path`] = []
      }
    },
    showPolygonName(event, payload) {
      Vue.set(
        this.infoOfficialFenceSelected,
        'name',
        this[`${payload.key}Selected`][payload.index]
      )
      Vue.set(
        this.infoOfficialFenceSelected,
        'zone',
        zonesNamesRefs.get(payload.key).name
      )
      Vue.set(
        this.infoOfficialFenceSelected,
        'color',
        zonesNamesRefs.get(payload.key).color
      )
      this.$refs.infoBubbleOFRef.style.position = 'absolute'
      this.$refs.infoBubbleOFRef.style.left = `${event.domEvent.x - 80}px`
      this.$refs.infoBubbleOFRef.style.top = `${event.domEvent.y - 68}px`
      this.$refs.infoBubbleOFRef.style.zIndex = 7
      this.showOfficialFenceName = true
    }
  }
  // beforeRouteEnter(to, from, next) {
  //   console.log('beforeRouteEnter to: ', to)
  //   console.log('beforeRouteEnter from: ', from)
  //   next()
  //   // this.saveFromRoute(from)
  // }
}



// WEBPACK FOOTER //
// ./src/mixins/officialZonesMixin.js